export const envConfig = {
  appMode: import.meta.env.MODE,
  appVersion: import.meta.env.VITE_APP_VERSION,
  coreApiBaseUrl: import.meta.env.VITE_CORE_API_BASE_URL,
  baselineDefaultId: import.meta.env.VITE_BASELINE_DEFAULT_ID,
  baselineUsAdultsId: import.meta.env.VITE_BASELINE_US_ADULTS_ID,
  baselineUsGenPopId: import.meta.env.VITE_BASELINE_US_GEN_POP_ID,
  baselineUsHispanicId: import.meta.env.VITE_BASELINE_US_HISPANIC_ID,
  baselineUsNonHispanicId: import.meta.env.VITE_BASELINE_US_NON_HISPANIC_ID,
  audienceDefaultId: import.meta.env.VITE_AUDIENCE_DEFAULT_ID,
  gtmId: import.meta.env.VITE_GTM_ID,
  bugsnagApiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
  bugsnagReleaseStage: import.meta.env.VITE_BUGSNAG_RELEASE_STAGE,
  auth0Domain: import.meta.env.VITE_AUTH0_DOMAIN,
  auth0ClientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  auth0Audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  posthogKey: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
  posthogHost: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
};

const { appMode } = envConfig;

export const isAppModeLocal = () => appMode === "development";

export const isAppModeQA = () => appMode === "qa";

export const isAppModeProd = () => appMode === "production";

export const isAppModeLocalOrQA = () => isAppModeLocal() || isAppModeQA();
